import { handleActions } from 'redux-actions';
import { GET_LOGOUT_REASON, GET_LOGOUT_REASON_DETAIL } from '../actionTypes';
import { logoutReason } from '../initialState';

export default handleActions(
  {
    [GET_LOGOUT_REASON]: (state, action) => {
      return {
        ...state,
        reason: action.payload
      };
    },
    [GET_LOGOUT_REASON_DETAIL]: (state, action) => {
      return {
        ...state,
        reason_detail: action.payload
      };
    }
  },
  logoutReason
);
